import { API, graphqlOperation } from "aws-amplify";
import LocalizedStrings from "react-localization";
import toast from "react-hot-toast";
import { useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import { Loader } from "@aws-amplify/ui-react";

import CostCenterForm from "components/costCenters/CostCenterForm";
import { updateCostCenter } from "graphql/mutations";
import { getCostCenter } from "graphql/queries";

const CostCenterUpdateForm = ({ costCenterId, onSuccess }) => {
  const navigate = useNavigate();
  const [costCenter, setCostCenter] = useState();

  async function onSubmit(valuesParam) {
    try {
      const {
        code,
        name,
        companyID,
      } = valuesParam;

      await API.graphql({
        query: updateCostCenter.replaceAll("__typename", ""),
        variables: {
          input: {
            id: costCenterId,
            code,
            name,
            companyID,
          },
        },
      });

      toast.success(strings.successUpdated);
      if (onSuccess) onSuccess();
      else navigate("/cost-centers");
    } catch (err) {
      toast.error(strings.responses[err]);
    }
  }

  async function fetchCostCenter(id) {
    try {
      const costCenterData = await API.graphql(graphqlOperation(getCostCenter, { id }));
      const costCenterItem = costCenterData.data.getCostCenter;
      if (!costCenterItem) {
        toast.error(strings.responses.errorFetch);
        navigate("/cost-centers");
        return;
      }
      setCostCenter(costCenterItem);
    } catch (err) {
      toast.error(strings.responses.errorFetch);
    }
  }

  useEffect(() => {
    fetchCostCenter(costCenterId);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [costCenterId]);

  if (!costCenter) return <Loader />;

  return (
    <div>
      <CostCenterForm onSubmit={onSubmit} type="update" initialValues={costCenter} />
    </div>
  );
};

const strings = new LocalizedStrings({
  es: {
    title: "Actualizar Centro de Costo",
    successUpdated: "Centro de Costo actualizado con éxito",
    responses: {
      errorFetch: "Error al consultar el centro de costo",
    },
  },
});

export default CostCenterUpdateForm;
